import script from "./mobileInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileInformation.vue?vue&type=script&setup=true&lang=js"

import "./mobileInformation.vue?vue&type=style&index=0&id=54247a75&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54247a75"]])

export default __exports__